// extracted by mini-css-extract-plugin
module.exports = {"container":"_1B-k-pJ58makvieT"};